(() => {
  const isYes = (value) => {
    if (!value) return false;
    const normalized = value.toString().trim().toLowerCase();
    return normalized === 'yes' || normalized === 'y';
  };

  const getOptionValue = (variantPicker, optionIndex) => {
    if (optionIndex == null || Number.isNaN(optionIndex)) return null;

    if (variantPicker.tagName === 'VARIANT-RADIOS') {
      const fieldsets = variantPicker.querySelectorAll('fieldset');
      return fieldsets[optionIndex]?.querySelector('input:checked')?.value ?? null;
    }

    const selects = variantPicker.querySelectorAll('select');
    return selects[optionIndex]?.value ?? null;
  };

  const initFramedGallery = (gallery) => {
    const section = gallery.closest('[data-frame-option-index], [data-mount-option-index]');
    const mountPicker = section?.querySelector('[data-framed-mount-picker]');
    if (!section && !mountPicker) return;

    const config = {
      frameOptionIndex:
        section?.dataset.frameOptionIndex != null
          ? Number(section.dataset.frameOptionIndex)
          : null,
      mountOptionIndex:
        section?.dataset.mountOptionIndex != null
          ? Number(section.dataset.mountOptionIndex)
          : null,
      handles: JSON.parse(section?.dataset.frameHandles || '{}'),
    };

    const sectionId = gallery.dataset.sectionId;
    const variantPicker =
      document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
      document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    const mountPropertyInput = mountPicker?.querySelector('[data-framed-mount-property]');

    const syncMountProperty = (mountValue) => {
      if (!mountPropertyInput || !mountPicker) return;

      const isPrintOnly = gallery.dataset.frame === 'no-frame';
      const yesLabel = mountPicker.dataset.yesLabel || 'Yes';
      const noLabel = mountPicker.dataset.noLabel || 'No';

      if (isPrintOnly) {
        mountPropertyInput.disabled = true;
        mountPropertyInput.value = noLabel;
        return;
      }

      mountPropertyInput.disabled = false;
      mountPropertyInput.value = mountValue === 'yes' ? yesLabel : noLabel;
    };

    const syncMountPickerVisibility = () => {
      if (!mountPicker) return;
      const isPrintOnly = gallery.dataset.frame === 'no-frame';
      mountPicker.classList.toggle('framed-mount-picker--hidden', isPrintOnly);
    };

    const updateMount = () => {
      if (config.mountOptionIndex != null && variantPicker) {
        const mountValue = getOptionValue(variantPicker, config.mountOptionIndex);
        const normalizedMount = isYes(mountValue) ? 'yes' : 'no';
        gallery.setAttribute('data-mount', normalizedMount);
        syncMountPickerVisibility();
        return;
      }

      if (!mountPicker) return;

      const checked = mountPicker.querySelector('input[name^="framed-mount-"]:checked');
      const mountValue = checked?.value === 'yes' ? 'yes' : 'no';
      gallery.setAttribute('data-mount', mountValue);
      syncMountPickerVisibility();
      syncMountProperty(mountValue);
    };

    const updateFrame = () => {
      if (config.frameOptionIndex == null || !variantPicker) return;

      const frameValue = getOptionValue(variantPicker, config.frameOptionIndex);
      if (!frameValue) return;

      const frameHandle =
        config.handles[frameValue] ||
        frameValue
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');

      gallery.setAttribute('data-frame', frameHandle);
      syncMountPickerVisibility();

      const checked = mountPicker?.querySelector('input[name^="framed-mount-"]:checked');
      syncMountProperty(checked?.value === 'yes' ? 'yes' : 'no');
    };

    const updateGallery = () => {
      updateFrame();
      updateMount();
    };

    if (variantPicker) {
      variantPicker.addEventListener('change', updateGallery);
    }

    if (mountPicker) {
      mountPicker.addEventListener('change', updateMount);
    }

    updateGallery();
  };

  const init = () => {
    document.querySelectorAll('.framed-gallery').forEach(initFramedGallery);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.framed-gallery').forEach(initFramedGallery);
  });
})();
